import type { Permissions } from '~/types/code/code';

/**
 * 権限の列挙型
 */
export const PermissionsEnum: Record<Permissions, Permissions> = {
  /** 荷役作業受付 */
  CARGO_ENTRY: 'CARGO_ENTRY',
  /** 列車運行状況 */
  TRAIN_STATUS: 'TRAIN_STATUS',
  /** 駅からのお知らせ */
  STATION_NOTICE: 'STATION_NOTICE',
  /** 代理ログイン（荷役作業受付） */
  PROXY_LOGIN_CH: 'PROXY_LOGIN_CH',
  /** 代理ログイン（管理者用） */
  PROXY_LOGIN_MAX: 'PROXY_LOGIN_MAX',
  /** Webアカウント申請（変更） */
  WEB_ACC_APPLY_MOD: 'WEB_ACC_APPLY_MOD',
  /** アカウント承認 */
  ACC_APPROVE: 'ACC_APPROVE',
  /** 権限管理 */
  AUTH_MGMT: 'AUTH_MGMT',
  /** アカウント管理（変更・削除） */
  ACC_MGMT_MOD_DEL: 'ACC_MGMT_MOD_DEL',
  /** パスワード初期化 */
  PW_INIT: 'PW_INIT',
  /** ロック解除 */
  UNLOCK: 'UNLOCK',
  /** ログイン用QRコード出力 */
  QR_OUTPUT: 'QR_OUTPUT',
} as const;
